/* eslint-disable max-len */
import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders,
} from "utils/helpers";

const queryFn = (accessToken: string, buildingModelCarbonReductionPlanId: string) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {buildingModelCarbonReductionPlanId},
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (data.carbonReductionPlanReports.error)
            throw new Error(data.carbonReductionPlanReports.error);
        else
            return data.carbonReductionPlanReports
                ?.annualEmissionSavingsByMeasureChart as AnnualEmissionSavingsByMeasureChartData;
    });

const query = graphql(`
    query buildingModelRecommendationsAnnualEmissionSavingsByMeasureChart(
        $buildingModelCarbonReductionPlanId: Uuid!
    ) {
        carbonReductionPlanReports(buildingModelCarbonReductionPlanId: $buildingModelCarbonReductionPlanId) {
            error
            annualEmissionSavingsByMeasureChart {
                carbonEmissionSavingsFromGrid
                carbonReductionMeasureCategories {
                    carbonReductionMeasureCategory
                    totalCarbonEmissionSavings
                }
                remainingCarbonEmissions
                year
            }
        }
    }
`);

export default queryFn;
